import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as nextReducer from "containers/Next/NextReducer";

import DoubleOutcomeChart from "components/Next/Charts/DoubleOutcomeChart";

const getId = (props) =>
  props && props.id
    ? props.id
    : props.datasetId
      ? props.datasetId
      : props && props.match && props.match.params && props.match.params.datasetId
        ? props.match.params.datasetId
        : "new";

class DoubleOutcomeChartContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <DoubleOutcomeChart {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {};
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);

  return {
    id: id,
    dataset: homeReducer.getDataset(state, id),

    chartType: nextReducer.getChartType(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DoubleOutcomeChartContainer);
